export default {"src":"/_next/static/media/base.16bd1644.svg","height":30,"width":30};